import Link from "next/link";
import { bestSellingModels } from "../../models";
import { SwModelsProps } from "../../props";
import styles from "./sw-models-variant-01.module.scss";
import { vehicleLinkBuilderByReference } from "@/components/package-components/utils";

export const SwModelsVariant01 = (props: SwModelsProps) => {
  const vehicles = props.data?.vehicleList ?? [];
  const availableModels = Array.from(
    new Set(
      vehicles.map((vehicle) => {
        if (
          bestSellingModels.includes(vehicle.model.toLowerCase()) &&
          vehicle.model != undefined
        ) {
          return { model: vehicle.model, make: vehicle.make };
        }
      })
    )
  );

  const site = props.data.site;

  return (
    <section className={`${styles.section} container-${props.id}`}>
      <div className={`${styles.container} container-${props.id}`}>
        <h1 className={`${styles.title} title-${props.id}`}>
          Modelos mais buscados
        </h1>
        <div
          className={`${styles.content__container} content__container-${props.id}`}
        >
          {availableModels.slice(0, 10).map((item, index) => {
            if (!item?.model) {
              return;
            }

            const currentLink =
              vehicleLinkBuilderByReference({
                ref: "model",
                value: item.model,
                site: {
                  subdomain: site?.subdomain as string,
                  customDomain: site?.customDomain ?? "",
                  preferences: site?.preferences ?? [],
                },
                vehicleList: props.data.vehicleList,
              }) ?? "/";

            return (
              <Link
                className={`${styles.card} card-${props.id}`}
                href={currentLink}
                key={`vehicle-${index}`}
              >
                <p className={`${styles.make}`}>{item.make}</p>
                <p className={`${styles.model}`}>{item.model}</p>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
};
